export const INACTIVATE_PAPEL_TITLE = "Inativar Papel";
export const INACTIVATE_PAPEL_MESSAGE =
  "Ao inativar o papel, ele deixa de ser exigido nas novas obras e não poderá ser adicionado até que seja ativado novamente.";
export const INACTIVATE_PAPEL_CARD_TITLE = "Papel que será inativado";
export const INACTIVATE_PAPEL_JANELA_LABEL = "Janela";
export const INACTIVATE_PAPEL_CONFIRM_LABEL = "Inativar Papel";
export const JUSTIFICATIVA_LABEL = "Justificativa";
export const JUSTIFICATIVA_REQUIRED_HINT = "(Campo obrigatório)";
export const JUSTIFICATIVA_REQUIRED_MESSAGE = "Campo obrigatório";
/**
 * Limite da coluna `justificativa` da auditoria (VARCHAR(200)). O core aceita até 255:
 * a divergência é pendência de produto.
 */
export const JUSTIFICATIVA_MAX_LENGTH = 200;
